import { useDestinationsContext } from '../../context';
import { AlertsWebhookListItem } from '../../types';
import { AlertWebhook } from './AlertWebhook';

export const AlertWebhooksList = () => {
  const {
    savedWebhooks: { webhooks },
  } = useDestinationsContext();

  return (
    <>
      {webhooks?.map((webhook: AlertsWebhookListItem) => (
        <AlertWebhook key={webhook.id} webhook={webhook} />
      ))}
    </>
  );
};
